module.exports = __webpack_public_path__ + "static/media/377.534e2e44.svg";